import { useLayoutEffect, useRef, useState } from 'react'

/**
 * The rendered width of an element, kept current as it resizes. The SVG
 * charts draw themselves at the container's real pixel width so their text
 * stays the same size on a phone and on a wide desktop card.
 */
export function useMeasuredWidth<T extends HTMLElement>(fallback: number) {
  const ref = useRef<T>(null)
  const [width, setWidth] = useState(fallback)

  useLayoutEffect(() => {
    const element = ref.current
    if (!element || typeof ResizeObserver === 'undefined') {
      return
    }
    const update = () => {
      const measured = element.getBoundingClientRect().width
      if (measured > 0) {
        setWidth(measured)
      }
    }
    update()
    const observer = new ResizeObserver(update)
    observer.observe(element)
    return () => observer.disconnect()
  }, [])

  return { ref, width }
}
